import {AppType} from './app';

export type TRoundingRules = Array<{
  min: number;
  text: string;
}>;

export const YANDEX_AD_MODES = [
  'none',
  'banner',
  'floor_ad',
  'floor_ad_closed',
  'floor_ad_banner',
  'floor_ad_banner_scroll',
  'floor_ad_closed_copy',
] as const;

export const SSP_AD_MODES = [
  'none',
  'ssp_floor_ad',
  'ssp_floor_ad_closed',
] as const;

export const SSP_PARTNER_AD_MODES = ['none', 'ssp_floor_ad_partner'] as const;

export const WEB_AUTO_LOGIN = ['none', 'snackbar', 'headerAvatar'] as const;

export const NEW_MAIN_PAGE_BLOCK_TYPES = [
  /** подборка, где приложения показываются в виде карточек со скриншотами */
  'selection_with_app_cards',
  /** топ игр/приложений */
  'top_apps',
  /** подборка, где приложения показываются в виде простого списка */
  'selection_with_app_list',
  /** блок со ссылками на подборки */
  'selection_cards',
  /** блок со статьями простора */
  'articles',
  /** блок с событиями */
  'events',
] as const;

export type YandexAdMode = (typeof YANDEX_AD_MODES)[number];
export type SSPAdMode = (typeof SSP_AD_MODES)[number];
export type SspPartnerAdMode = (typeof SSP_PARTNER_AD_MODES)[number];
export type AutologinMode = (typeof WEB_AUTO_LOGIN)[number];
export type NewMainPageBlockType = (typeof NEW_MAIN_PAGE_BLOCK_TYPES)[number];
export type NewMainPageBlocksOrderConfig = Record<
  AppType,
  Array<NewMainPageBlockType>
>;

export const AD_REFRESH_TRIGGERS = [
  'timer',
  'window_focus',
  'navigation',
] as const;
export type AdRefreshTrigger = (typeof AD_REFRESH_TRIGGERS)[number];

export type AdFoxConfig = {
  enabled: boolean;
  /** https://yandex.ru/support2/adfox/ru/codes/code-loader#lazyload  */
  lazyLoad?: AdFox.EmbedCode['lazyLoad'];
  autorefresh?: {
    intervalMs: number;
    triggers: Array<AdRefreshTrigger>;
    logging?: boolean;
  };
  statSendingIntervalMs?: number;
};

export const METADATA_OVERRIDE_LOAD_MODES = [
  /** не запрашивать оверрайды */
  'none',
  /** запрашивать их к каждой странице */
  'per_page',
  /**
   * запрашивать их все периодически и доставать из локального кеша
   * (использовать пока количество относительно небольшое или если от per_page лопнет страпи)
   */
  'batch',
] as const;

export type MetadataOverrideLoadMode =
  (typeof METADATA_OVERRIDE_LOAD_MODES)[number];

export type YandexMetrikaFeatures = {
  clickmap: boolean;
  trackLinks: boolean;
  accurateTrackBounce: boolean;
  webvisor: boolean;
};

export const ENGAGEMENT_POPUP_VARIANTS = ['static', 'animated'] as const;

export type EngagementPopupVariant = (typeof ENGAGEMENT_POPUP_VARIANTS)[number];

export type PopupOptions =
  | {enabled: false}
  | {
      enabled: true;
      showAfterMillis: number;
      showAfterScroll: boolean;
      repeatedShowAfterSeconds?: number;
      appTypes?: AppType[];
    };

export type EngagementPopupOptions =
  | {enabled: false}
  | ({
      variant: EngagementPopupVariant;
    } & Extract<PopupOptions, {enabled: true}>);
